import React, { useState, useEffect } from 'react';
import { FeatherX } from '../ui/icons';
import TaskConversationViewer from './TaskConversationViewer';
import { managerApi } from '../../services/api';
import { isManager } from '../../utils/roleUtils';
import api from '../../services/api';
import '../DailyReview/TaskDetailModal.css';

const TaskManagerDiscussions = ({ taskId, taskTitle, taskDescription }) => {
    const [userIsManager, setUserIsManager] = useState(false);
    const [showConversations, setShowConversations] = useState(false);
    const [conversations, setConversations] = useState([]);
    const [selectedConversation, setSelectedConversation] = useState(null);
    const [loadingConversations, setLoadingConversations] = useState(false);

    useEffect(() => {
        if (taskId) {
            checkUserRole();
        }
    }, [taskId]);

    useEffect(() => {
        if (taskId && userIsManager) {
            loadConversations();
        }
    }, [taskId, userIsManager]);

    const checkUserRole = async () => {
        try {
            const response = await api.get('/api/auth/role');
            const userRole = response.data?.role;
            setUserIsManager(isManager(userRole));
        } catch (err) {
            console.error('Error checking user role:', err);
        }
    };

    const loadConversations = async () => {
        if (!taskId) return;
        setLoadingConversations(true);
        try {
            const response = await managerApi.getTaskConversations(taskId);
            if (response.success && response.data) {
                setConversations(response.data);
            }
        } catch (error) {
            console.error('Error loading conversations:', error);
        } finally {
            setLoadingConversations(false);
        }
    };

    if (!userIsManager) return null;

    return (
        <>
            {/* Conversations Section (Manager Only) */}
            <div className="task-detail-modal-section task-detail-modal-section-conversations">
                <div className="task-detail-modal-conversations-header">
                    <h4 className="task-detail-modal-conversations-title">
                        Manager Discussions
                        {conversations.length > 0 && (
                            <span className="task-detail-modal-conversations-count">
                                ({conversations.length})
                            </span>
                        )}
                    </h4>
                    <button
                        className="task-detail-modal-conversations-toggle"
                        onClick={() => setShowConversations(!showConversations)}
                    >
                        {showConversations ? 'Hide' : 'Show'}
                    </button>
                </div>
                {showConversations && (
                    <div className="task-detail-modal-conversations-content">
                        {loadingConversations ? (
                            <div className="task-detail-modal-conversations-loading">
                                Loading conversations...
                            </div>
                        ) : conversations.length === 0 ? (
                            <div className="task-detail-modal-conversations-empty">
                                No conversations found for this task.
                            </div>
                        ) : (
                            <div className="task-detail-modal-conversations-list">
                                {conversations.map((conv, index) => (
                                    <div
                                        key={conv.id || index}
                                        className={`task-detail-modal-conversation-item ${selectedConversation?.id === conv.id ? 'active' : ''}`}
                                        onClick={() => setSelectedConversation(conv)}
                                    >
                                        <div className="task-detail-modal-conversation-item-header">
                                            <span className="task-detail-modal-conversation-item-date">
                                                {new Date(conv.workPlanDate).toLocaleDateString('en-US', {
                                                    month: 'short',
                                                    day: 'numeric',
                                                    year: 'numeric'
                                                })}
                                            </span>
                                            {conv.user && (
                                                <span className="task-detail-modal-conversation-item-user">
                                                    {conv.user.name}
                                                </span>
                                            )}
                                        </div>
                                        <div className="task-detail-modal-conversation-item-preview">
                                            {conv.conversationMessages?.[0]?.content?.substring(0, 100) || 'No messages'}
                                            {conv.conversationMessages?.[0]?.content?.length > 100 ? '...' : ''}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* Selected Conversation Viewer */}
            {selectedConversation && (
                <div className="task-detail-modal-conversation-viewer-container">
                    <div className="task-detail-modal-conversation-viewer-header">
                        <h4>Conversation Details</h4>
                        <button
                            className="task-detail-modal-conversation-viewer-close"
                            onClick={() => setSelectedConversation(null)}
                        >
                            <FeatherX size={18} />
                        </button>
                    </div>
                    <div className="task-detail-modal-conversation-viewer-wrapper">
                        <TaskConversationViewer
                            conversation={selectedConversation.conversationMessages || []}
                            taskTitle={selectedConversation.taskTitle || taskTitle}
                            taskDescription={taskDescription}
                            userName={selectedConversation.user?.name}
                            workPlanDate={selectedConversation.workPlanDate}
                            taskStatusAtTime={selectedConversation.taskStatusAtTime}
                            project={selectedConversation.project}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default TaskManagerDiscussions;
